import { useEffect, useState } from 'react';
import { pricingApi } from '@/services/api';

const DEBOUNCE_MS = 250;

/**
 * The back end's price for an order, kept current as the request changes. `request` comes from buildQuoteRequest, or is
 * null while there is nothing to price. A newer request supersedes an older one that is still in flight.
 */
export const useOrderQuote = (request) => {
  const [state, setState] = useState({ quote: null, loading: false, error: null });
  const requestKey = request ? JSON.stringify(request) : '';

  useEffect(() => {
    if (!requestKey) {
      setState({ quote: null, loading: false, error: null });
      return undefined;
    }
    let superseded = false;
    setState((previous) => ({ ...previous, loading: true, error: null }));
    const timer = setTimeout(async () => {
      try {
        const quote = await pricingApi.quote(JSON.parse(requestKey));
        if (!superseded) setState({ quote, loading: false, error: null });
      } catch (err) {
        if (!superseded) setState({ quote: null, loading: false, error: err?.message || 'Could not price this order' });
      }
    }, DEBOUNCE_MS);
    return () => {
      superseded = true;
      clearTimeout(timer);
    };
  }, [requestKey]);

  return state;
};
